/* Sign-up forms: sheets that swipe up from the bottom of the page (sections/signup-forms.liquid).

   A sheet opens from its card's button, from any link on the page whose address ends in the
   sheet's name (#volunteer-form, /pages/volunteer#kitchen-crew-form …), and on arrival
   when the address already carries that name, which is also how Shopify returns after a
   send (?contact_posted=true#volunteer-form): the sheet then opens on its thank-you.
   It closes with its Close button, the dimmed page behind it, Escape, or a swipe down on
   its top bar. While open, the page behind is inert (no focus, no clicks, no scrolling).

   The forms post the ordinary way, to Shopify's contact form (which may stop to ask for a
   captcha); the script only checks the day picks before letting a form go. The copy for the
   Google Sheet is put aside as the form goes, and sent from the thank-you page Shopify
   returns to, so a send Shopify refused, or a captcha left unanswered, never reaches the
   sheet, and a double click can't send two. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  if (window.HereticSignup) { window.HereticSignup.scan(); return; }
  root.classList.add('sf-js');

  var sheets = Object.create(null), openSheet = null, lastFocus = null, inerted = [];
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var STASH = 'sf-copy:', STASH_LIFE = 30 * 60000;

  function $$(sel, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(sel)); }
  function nameOf(hash) { try { return decodeURIComponent(String(hash || '').replace(/^#/, '')); } catch (e) { return ''; } }
  function has(name) { return !!name && Object.prototype.hasOwnProperty.call(sheets, name); }
  function calm() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }

  /* Each sheet moves to the end of <body> so no section's styling can hold it in place. */
  function scan() {
    $$('[data-sf-sheet]').forEach(function (sheet) {
      if (sheet.dataset.sfBound) return;
      sheet.dataset.sfBound = '1';
      var name = sheet.getAttribute('data-sf-sheet');
      if (has(name) && sheets[name] !== sheet && doc.body.contains(sheets[name])) sheets[name].remove();
      sheets[name] = sheet;
      doc.body.appendChild(sheet);
      sheet.setAttribute('inert', '');
      sheet.setAttribute('aria-hidden', 'true');
      bindSheet(sheet);
    });
  }

  function bindSheet(sheet) {
    $$('[data-sf-close]', sheet).forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
    var form = sheet.querySelector('form.sf-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        /* one send at a time: a second click while the first is on its way does nothing */
        if (form.dataset.sfPending === '1') { e.preventDefault(); return; }
        if (!check(form)) { e.preventDefault(); return; }
        putAside(sheet, form);
        sending(form);
      });
      /* the commitment question: the answer is kept on the form, so the rest shows or the
         "sorry" note does even where the browser can't do it from the CSS alone */
      var say = sheet.querySelector('[data-sf-say]');
      $$('[data-sf-gate]', form).forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          var yes = r.getAttribute('data-sf-gate') === 'yes';
          form.setAttribute('data-sf-answer', yes ? 'yes' : 'no');
          if (say) say.textContent = yes ? '' : textOf(sheet.querySelector('.sf-sorry'));
        });
      });
      if (form.querySelector('[data-sf-gated]')) {
        var picked = form.querySelector('[data-sf-gate]:checked');
        form.setAttribute('data-sf-answer', picked ? picked.getAttribute('data-sf-gate') : '');
      }
    }
    /* a day: marked open while ticked; un-ticked, it forgets its shift, so the email never
       lists a day they took back. Focus stays on the day; the shifts follow it in Tab order. */
    $$('[data-sf-daybox]', sheet).forEach(function (box) {
      var day = box.closest('[data-sf-day]');
      if (day) day.classList.toggle('is-on', box.checked);
      box.addEventListener('change', function () {
        if (day) {
          day.classList.toggle('is-on', box.checked);
          if (!box.checked) $$('.sf-shifts input', day).forEach(function (r) { r.checked = false; });
        }
        hideAvailError(sheet);
      });
    });
    $$('.sf-shifts input', sheet).forEach(function (r) { r.addEventListener('change', function () { hideAvailError(sheet); }); });
    dragToClose(sheet);
  }

  function textOf(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function hideAvailError(sheet) { var err = sheet.querySelector('[data-sf-avail-error]'); if (err) err.hidden = true; }

  /* At least one day, and a shift for every ticked day that has a choice. */
  function check(form) {
    var avail = form.querySelector('[data-sf-avail]');
    if (avail) {
      var days = $$('[data-sf-day]', avail), picked = 0, missing = null;
      days.forEach(function (day) {
        var box = day.querySelector('[data-sf-daybox]');
        if (!box || !box.checked) return;
        picked++;
        var radios = $$('.sf-shifts input', day);
        if (radios.length && !radios.some(function (r) { return r.checked; }) && !missing) missing = radios[0];
      });
      if (!picked || missing) {
        var err = avail.querySelector('[data-sf-avail-error]');
        if (err) { err.hidden = false; err.setAttribute('role', 'alert'); }
        var target = missing || avail.querySelector('[data-sf-daybox]');
        if (target) { target.focus({ preventScroll: true }); (target.closest('[data-sf-day]') || avail).scrollIntoView({ block: 'center', behavior: calm() ? 'auto' : 'smooth' }); }
        return false;
      }
    }
    return true;
  }

  /* The copy for the Google Sheet (through the people-fed worker): one column per question, in
     the form's order (blank when unanswered, so every row lines up), multi-answer questions
     joined. Put aside in this tab's session storage until Shopify's thank-you comes back. */
  function copyOf(sheet, form) {
    var url = sheet.getAttribute('data-sf-relay');
    if (!url || !/^https:\/\//i.test(url)) return null;
    var fields = Object.create(null), order = [];
    function put(key, value, join) {
      if (!Object.prototype.hasOwnProperty.call(fields, key)) { fields[key] = ''; order.push(key); }
      if (value) fields[key] = join && fields[key] ? fields[key] + ', ' + value : value;
    }
    var NICE = { name: 'Name', email: 'Email', phone: 'Phone' };
    var formName = '';
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.hasAttribute && el.hasAttribute('data-sf-formname')) { formName = el.value; return; }
      var m = /^contact\[(.+)\]$/.exec(el.name || '');
      if (!m || el.disabled) return;
      var key = m[1], on = el.type === 'radio' || el.type === 'checkbox' ? el.checked : true;
      var multi = / · /.test(key) && el.type === 'checkbox';
      if (multi) { var parts = key.split(' · '); put(parts[0], on ? parts.slice(1).join(' · ') : '', true); return; }
      put(Object.prototype.hasOwnProperty.call(NICE, key) ? NICE[key] : key, on ? String(el.value || '').trim() : '');
    });
    var trap = form.querySelector('[data-sf-trap]');
    var plain = {}; order.forEach(function (k) { plain[k] = fields[k]; });
    return { url: url, body: JSON.stringify({ form: formName, fields: plain, order: order, page: location.pathname, website: trap ? trap.value : '' }) };
  }
  function send(copy) {
    if (!copy || typeof fetch !== 'function') return;
    try {
      fetch(copy.url, { method: 'POST', body: copy.body, headers: { 'content-type': 'text/plain;charset=UTF-8' }, keepalive: copy.body.length < 60000, credentials: 'omit', mode: 'cors' }).catch(function () {});
    } catch (e) { /* the email has gone either way */ }
  }
  function putAside(sheet, form) {
    var copy = copyOf(sheet, form);
    if (!copy) return;
    try {
      sessionStorage.setItem(STASH + sheet.getAttribute('data-sf-sheet'), JSON.stringify({ at: Date.now(), url: copy.url, body: copy.body }));
    } catch (e) {
      send(copy); /* no session storage here (some private windows): send it now, as the form goes */
    }
  }
  /* The copy put aside for this form, taken (so a reload never sends it twice). Without a name
     (a captcha page that dropped the #name on the way back): the newest one put aside. */
  function takeAside(name) {
    try {
      var key = name ? STASH + name : null;
      if (!key) {
        var newest = 0;
        for (var i = 0; i < sessionStorage.length; i++) {
          var k = sessionStorage.key(i);
          if (!k || k.indexOf(STASH) !== 0) continue;
          var at = (JSON.parse(sessionStorage.getItem(k)) || {}).at || 0;
          if (at > newest) { newest = at; key = k; }
        }
        if (!key) return null;
      }
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      sessionStorage.removeItem(key);
      var copy = JSON.parse(raw);
      if (!copy || typeof copy.body !== 'string' || !/^https:\/\//i.test(String(copy.url)) || !(Date.now() - copy.at < STASH_LIFE)) return null;
      copy.name = key.slice(STASH.length);
      return copy;
    } catch (e) { return null; }
  }
  /* Shopify sent the form back with a message: that copy is dropped (a corrected send puts aside a new one) */
  function dropAside(name) { try { sessionStorage.removeItem(STASH + name); } catch (e) { /* nothing to drop */ } }
  /* and nothing put aside outlives half an hour: what someone typed doesn't linger in the tab */
  function dropOld() {
    try {
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var k = sessionStorage.key(i);
        if (k && k.indexOf(STASH) === 0 && !(Date.now() - ((JSON.parse(sessionStorage.getItem(k)) || {}).at || 0) < STASH_LIFE)) sessionStorage.removeItem(k);
      }
    } catch (e) { /* no session storage here */ }
  }

  function sending(form) {
    var btn = form.querySelector('[data-sf-send]');
    form.dataset.sfPending = '1';
    if (!btn) return;
    if (!btn.hasAttribute('data-sf-label')) btn.setAttribute('data-sf-label', btn.textContent);
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Sending…';
    /* if the page is still here a while later (offline, a captcha in another tab), the button comes back */
    clearTimeout(form._sfBack);
    form._sfBack = setTimeout(function () { ready(form); }, 12000);
  }
  function ready(form) {
    var btn = form.querySelector('[data-sf-send]');
    form.dataset.sfPending = '';
    if (btn && btn.hasAttribute('data-sf-label')) { btn.removeAttribute('aria-busy'); btn.textContent = btn.getAttribute('data-sf-label'); }
  }
  /* back to the page from the browser's cache (the Back button after a send): ready again */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    Object.keys(sheets).forEach(function (n) { var f = sheets[n].querySelector('form.sf-form'); if (f) ready(f); });
  });

  /* Keyboard order inside a sheet: the visible controls, and of each set of radio buttons only
     the one Tab reaches (the chosen one, or the first). */
  function tabbables(sheet) {
    var groups = {};
    return $$(FOCUSABLE, sheet).filter(function (el) {
      if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
      if (el.type === 'radio' && el.name) {
        var all = $$('input[type="radio"]', el.form || sheet).filter(function (r) { return r.name === el.name; });
        var on = all.filter(function (r) { return r.checked; })[0];
        if (on) return el === on;
        if (groups[el.name]) return false;
        groups[el.name] = true;
      }
      return true;
    });
  }
  /* everything else on the page goes inert while a sheet is open, and comes back after */
  function quietPage(sheet) {
    Array.prototype.forEach.call(doc.body.children, function (el) {
      if (el === sheet || el.hasAttribute('inert') || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
      el.setAttribute('inert', ''); inerted.push(el);
    });
  }
  function wakePage() { inerted.forEach(function (el) { el.removeAttribute('inert'); }); inerted = []; }

  function open(name, opts) {
    if (!has(name)) return false;
    var sheet = sheets[name];
    opts = opts || {};
    if (openSheet && openSheet !== sheet) close(false, true);
    if (openSheet === sheet) return true;
    lastFocus = opts.from || doc.activeElement;
    sheet.removeAttribute('inert');
    sheet.removeAttribute('aria-hidden');
    sheet.classList.toggle('is-sent', !!opts.sent);
    if (opts.sent && window.hereticTrack) window.hereticTrack('heretic_volunteer_signup', { form: name });
    doc.body.classList.add('sf-lock');
    quietPage(sheet);
    var scroll = sheet.querySelector('[data-sf-scroll]');
    if (scroll) scroll.scrollTop = 0;
    void sheet.offsetWidth; /* painted below the page first, so the rise has somewhere to start */
    sheet.classList.add('is-open');
    openSheet = sheet;
    var panel = sheet.querySelector('.sf-panel');
    var focusTo = opts.sent ? sheet.querySelector('[data-sf-thanks]') : opts.errors ? sheet.querySelector('[data-sf-errors]') || panel : panel;
    if (focusTo) { if (!focusTo.hasAttribute('tabindex')) focusTo.setAttribute('tabindex', '-1'); focusTo.focus({ preventScroll: true }); }
    if (opts.errors) { var errEl = sheet.querySelector('[data-sf-errors]'); if (errEl) errEl.scrollIntoView({ block: 'center' }); }
    if (!opts.keepHash && nameOf(location.hash) !== name && history.replaceState) history.replaceState(history.state, '', location.pathname + location.search + '#' + encodeURIComponent(name));
    return true;
  }

  function close(restoreFocus, quiet) {
    var sheet = openSheet;
    if (!sheet) return;
    openSheet = null;
    sheet.classList.remove('is-open');
    sheet.setAttribute('inert', '');
    sheet.setAttribute('aria-hidden', 'true');
    doc.body.classList.remove('sf-lock');
    wakePage();
    var panel = sheet.querySelector('.sf-panel');
    if (panel) panel.style.transform = '';
    /* the address loses the form's name, and the "sent" marker Shopify added */
    if (history.replaceState && !quiet) {
      var search = location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '');
      history.replaceState(history.state, '', location.pathname + search);
    }
    if (restoreFocus && lastFocus && lastFocus.focus && doc.body.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  /* Any link to #name opens that sheet, whatever page address comes before the #. */
  doc.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var name = nameOf(a.hash);
    if (!has(name)) return;
    e.preventDefault();
    open(name, { from: a });
  });

  /* Tab goes round inside the open sheet; Escape closes it. */
  doc.addEventListener('keydown', function (e) {
    if (!openSheet) return;
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    var items = tabbables(openSheet);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1], active = doc.activeElement;
    /* the sheet's own panel, or the page (body, or anything put to sleep behind the sheet) */
    var stray = active === openSheet.querySelector('.sf-panel') || active === doc.body || active === root || inerted.some(function (el) { return el.contains(active); });
    if (e.shiftKey && (active === first || stray)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (active === last || stray)) { e.preventDefault(); first.focus(); }
  });
  /* Browsers without `inert` (before 2023): if focus reaches the page behind, it comes back.
     Anything that appears on top later (a captcha, say) is left alone. */
  if (!('inert' in HTMLElement.prototype)) {
    doc.addEventListener('focusin', function (e) {
      if (!openSheet || openSheet.contains(e.target) || !inerted.some(function (el) { return el.contains(e.target); })) return;
      var items = tabbables(openSheet);
      (items[0] || openSheet.querySelector('.sf-panel')).focus({ preventScroll: true });
    });
  }

  window.addEventListener('hashchange', function () { var n = nameOf(location.hash); if (has(n)) open(n, { keepHash: true }); });

  /* A swipe down on the top bar closes the sheet; a short one springs back. */
  function dragToClose(sheet) {
    var bar = sheet.querySelector('[data-sf-drag]'), panel = sheet.querySelector('.sf-panel');
    if (!bar || !panel || !window.PointerEvent) return;
    var startY = 0, dy = 0, dragging = false, id = null;
    bar.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button') || openSheet !== sheet) return;
      dragging = true; startY = e.clientY; dy = 0; id = e.pointerId;
      try { bar.setPointerCapture(id); } catch (x) { /* fine */ }
      sheet.classList.add('is-dragging');
    });
    bar.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== id) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    });
    function end(e) {
      if (!dragging || (e && e.pointerId !== id)) return;
      dragging = false;
      sheet.classList.remove('is-dragging');
      if (dy > Math.min(160, panel.offsetHeight * 0.22)) close(true);
      else panel.style.transform = '';
    }
    bar.addEventListener('pointerup', end);
    bar.addEventListener('pointercancel', end);
  }

  /* On arrival: the address names a sheet (a link from another page, or Shopify coming back).
     Coming back from a send, the copy put aside for that form goes to the sheet now. */
  function arrive() {
    dropOld();
    var name = nameOf(location.hash);
    var posted = /[?&]contact_posted=true/.test(location.search);
    var copy = null;
    /* an address naming some other form (a contact form on the same page) is not a sheet's send */
    if (posted && (has(name) || !location.hash)) {
      copy = takeAside(has(name) ? name : null);
      if (copy && !has(name) && has(copy.name)) name = copy.name;
      if (copy) send(copy);
    }
    if (!has(name)) return;
    var sheet = sheets[name];
    var sent = posted && !!sheet.querySelector('[data-sf-posted]');
    var errors = !!sheet.querySelector('[data-sf-errors]');
    if (errors && !sent) dropAside(name);
    /* the browser may already have jumped to the form inside the hidden sheet */
    var y = window.scrollY;
    open(name, { sent: sent, errors: errors && !sent, keepHash: true });
    window.scrollTo(0, y);
  }

  /* In the theme editor: selecting a form's block opens its sheet; a reloaded section rebinds. */
  doc.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    Object.keys(sheets).forEach(function (n) { if (sheets[n].getAttribute('data-section') === id) { if (openSheet === sheets[n]) close(false, true); sheets[n].remove(); delete sheets[n]; } });
  });
  doc.addEventListener('shopify:section:load', function () { scan(); });
  doc.addEventListener('shopify:block:select', function (e) {
    var id = e.detail && e.detail.blockId;
    Object.keys(sheets).forEach(function (n) { if (sheets[n].getAttribute('data-block') === id) open(n, { keepHash: true }); });
  });
  doc.addEventListener('shopify:block:deselect', function () { close(false, true); });

  window.HereticSignup = { scan: scan, open: open, close: close };
  scan();
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { scan(); arrive(); }); else arrive();
})();
